// USGS and USWDS colors used across the application
export const USGS_BLUE = '#00264c';
export const USWDS_NAV_BLUE = '#162e51';
export const LINK_BLUE = '#005EA2';
export const TEXT_GRAY = '#565C65';
export const FOCUS_BLUE = '#2491ff';
export const LIGHT_GRAY = '#f0f0f0';
